import { bindUrl, request } from "./request";
export function getAdminUserDetail() {
  return request({
    // url: bindUrl("/oil/admin/user/detail", {}),
    url: bindUrl("/blade-user/information/accountInfo", {}),
    method: "GET"
  });
}
